import React from 'react'
import cx from 'classnames'
import { formatPrice } from 'helpers'

import { Grid, Cell } from 'components/layout/grid'

import s from './Totals.scss'


const Totals = ({ totals }) => (
  <Grid columns={1} gutter="md">
    {
      totals.map(([ title, space, amount ], index) => (
        <Cell
          key={index}
          className={cx({
            [s.red]: totals.length === index + 1,
          })}
          size={1}
        >
          <b>{title} {formatPrice(amount * 100)}</b>
        </Cell>
      ))
    }
  </Grid>
)


export default Totals
